import React from 'react'
import './configs/i18n'
import { BrowserRouter } from 'react-router-dom'
import AuthNavigation from '@BUP/navigations/AuthNavigation'

import './App.scss'

const App = () => {
  return (
    <BrowserRouter>
      <AuthNavigation />
    </BrowserRouter>
  )
}

export default App
